import { NotificationType } from '@api/READ_ONLY/notifications_api/Api';
import { JSX } from 'react';
import AssignmentBatchNotificationCard from './notificationsList/components/AssignmentBatchNotificationCard';
import CaregiverCashDepositNotificationCard from './notificationsList/components/CaregiverCashDepositNotificationCard';
import CompletedVisitNotificationCard from './notificationsList/components/CompletedVisitNotificationCard';
import DataExportNotificationCard from './notificationsList/components/DataExportNotificationCard';
import NoteAddedNotificationCard from './notificationsList/components/NoteAddedNotificationCard';
import DoctorInstructionNotificationCard from './notificationsList/components/DoctorInstructionNotificationCard';
import RejectedVisitNotificationCard from './notificationsList/components/RejectedVisitNotificationCard';
import ScheduleUpdatedNotificationCard from './notificationsList/components/ScheduleUpdatedNotificationCard';
import UpdatedVisitNotificationCard from './notificationsList/components/UpdatedVisitNotificationCard';
import VisitBatchNotificationCard from './notificationsList/components/VisitBatchNotificationCard';
import AssignmentBatchWidgetNotificationCard from './notificationsWidget/components/AssignmentBatchWidgetNotificationCard';
import CaregiverCashDepositWidgetNotificationCard from './notificationsWidget/components/CaregiverCashDepositWidgetNotificationCard';
import CompletedVisitWidgetNotificationCard from './notificationsWidget/components/CompletedVisitWidgetNotificationCard';
import DataExportWidgetNotificationCard from './notificationsWidget/components/DataExportWidgetNotificationCard';
import NoteAddedWidgetNotificationCard from './notificationsWidget/components/NoteAddedWidgetNotificationCard';
import DoctorInstructionWidgetNotificationCard from './notificationsWidget/components/DoctorInstructionWidgetNotificationCard';
import RejectedVisitWidgetNotificationCard from './notificationsWidget/components/RejectedVisitWidgetNotificationCard';
import ScheduleUpdatedWidgetNotificationCard from './notificationsWidget/components/ScheduleUpdatedWidgetNotificationCard';
import UpdatedVisitWidgetNotificationCard from './notificationsWidget/components/UpdatedVisitWidgetNotificationCard';
import VisitBatchWidgetNotificationCard from './notificationsWidget/components/VisitBatchWidgetNotificationCard';
import ShiftConflictNotificationCard from './notificationsList/components/ShiftConflictNotificationCard';
import ShiftConflictWidgetNotificationCard from './notificationsWidget/components/ShiftConflictWidgetNotificationCard';
import { DiscriminatedNotificationType } from './types/notifications';

type NotificationTypeProps = {
  notification: DiscriminatedNotificationType;
  onClick: () => void;
};

export const FullNotificationCardSelectorByType = (props: NotificationTypeProps): JSX.Element | null => {
  switch (props.notification.type) {
    case NotificationType.VisitUpdated:
      return <UpdatedVisitNotificationCard notificationDetails={props.notification} onClick={props.onClick} />;
    case NotificationType.VisitCompleted:
      return <CompletedVisitNotificationCard notificationDetails={props.notification} onClick={props.onClick} />;
    case NotificationType.VisitRejected:
      return <RejectedVisitNotificationCard notificationDetails={props.notification} onClick={props.onClick} />;
    case NotificationType.VisitAssignmentBatchAdded:
      return <AssignmentBatchNotificationCard notificationDetails={props.notification} onClick={props.onClick} />;
    case NotificationType.VisitScheduleUpdated:
      return <ScheduleUpdatedNotificationCard notificationDetails={props.notification} onClick={props.onClick} />;
    case NotificationType.VisitAssignmentAdded:
    case NotificationType.VisitAssignmentRemoved:
    case NotificationType.VisitRescheduled:
    case NotificationType.VisitCheckInReminder:
    case NotificationType.VisitCheckedIn:
    case NotificationType.AttachmentAdded:
    case NotificationType.AttachmentRemoved:
      return <UpdatedVisitNotificationCard notificationDetails={props.notification} onClick={props.onClick} />;
    case NotificationType.DataExportCompleted:
    case NotificationType.DataExportFailed:
      return <DataExportNotificationCard notificationDetails={props.notification} onClick={props.onClick} />;
    case NotificationType.VisitDeleteBatchCompleted:
    case NotificationType.VisitBillingSyncBatchCompleted:
    case NotificationType.VisitCompleteBatchCompleted:
      return <VisitBatchNotificationCard notificationDetails={props.notification} onClick={props.onClick} />;
    case NotificationType.CaregiverCashDepositRecorded:
      return <CaregiverCashDepositNotificationCard notificationDetails={props.notification} onClick={props.onClick} />;
    case NotificationType.NoteAdded:
      return <NoteAddedNotificationCard notificationDetails={props.notification} onClick={props.onClick} />;
    case NotificationType.DoctorInstructionSent:
    case NotificationType.DoctorInstructionDecided:
      return <DoctorInstructionNotificationCard notificationDetails={props.notification} onClick={props.onClick} />;
    case NotificationType.DeleteShiftConflict:
    case NotificationType.UpdateShiftConflict:
      return <ShiftConflictNotificationCard notificationDetails={props.notification} onClick={props.onClick} />;
    case NotificationType.ShiftUpdated:
    case NotificationType.ShiftDeleted:
      return null;
    default:
      return null;
  }
};

export const WidgetNotificationCardSelectorByType = (props: NotificationTypeProps): JSX.Element | null => {
  switch (props.notification.type) {
    case NotificationType.VisitUpdated:
      return <UpdatedVisitWidgetNotificationCard notificationDetails={props.notification} onClick={props.onClick} />;
    case NotificationType.VisitCompleted:
      return <CompletedVisitWidgetNotificationCard notificationDetails={props.notification} onClick={props.onClick} />;
    case NotificationType.VisitRejected:
      return <RejectedVisitWidgetNotificationCard notificationDetails={props.notification} onClick={props.onClick} />;
    case NotificationType.VisitAssignmentBatchAdded:
      return <AssignmentBatchWidgetNotificationCard notificationDetails={props.notification} onClick={props.onClick} />;
    case NotificationType.VisitScheduleUpdated:
      return <ScheduleUpdatedWidgetNotificationCard notificationDetails={props.notification} onClick={props.onClick} />;
    case NotificationType.VisitAssignmentAdded:
    case NotificationType.VisitAssignmentRemoved:
    case NotificationType.VisitRescheduled:
    case NotificationType.VisitCheckInReminder:
    case NotificationType.VisitCheckedIn:
    case NotificationType.AttachmentAdded:
    case NotificationType.AttachmentRemoved:
      return <UpdatedVisitWidgetNotificationCard notificationDetails={props.notification} onClick={props.onClick} />;
    case NotificationType.DataExportCompleted:
    case NotificationType.DataExportFailed:
      return <DataExportWidgetNotificationCard notificationDetails={props.notification} onClick={props.onClick} />;
    case NotificationType.VisitDeleteBatchCompleted:
    case NotificationType.VisitBillingSyncBatchCompleted:
    case NotificationType.VisitCompleteBatchCompleted:
      return <VisitBatchWidgetNotificationCard notificationDetails={props.notification} onClick={props.onClick} />;
    case NotificationType.CaregiverCashDepositRecorded:
      return (
        <CaregiverCashDepositWidgetNotificationCard notificationDetails={props.notification} onClick={props.onClick} />
      );
    case NotificationType.NoteAdded:
      return <NoteAddedWidgetNotificationCard notificationDetails={props.notification} onClick={props.onClick} />;
    case NotificationType.DoctorInstructionSent:
    case NotificationType.DoctorInstructionDecided:
      return (
        <DoctorInstructionWidgetNotificationCard notificationDetails={props.notification} onClick={props.onClick} />
      );
    case NotificationType.DeleteShiftConflict:
    case NotificationType.UpdateShiftConflict:
      return <ShiftConflictWidgetNotificationCard notificationDetails={props.notification} onClick={props.onClick} />;
    case NotificationType.ShiftUpdated:
    case NotificationType.ShiftDeleted:
      return null;
    default:
      return null;
  }
};
